export default __webpack_public_path__ + "static/media/totoro.df600aa8.jpg";